import { UserDataFragment } from "@bonliva-crm/graphql";

type MappedOption = Array<{
  label: string;
  value: UserDataFragment;
}>;

export function createUserOptions(users: UserDataFragment[]): MappedOption {
  const userOptions: Array<{
    label: string;
    value: UserDataFragment;
  }> = [];

  users.forEach((user) => {
    if (user.Deleted || !user.Enabled) return;
    const curr = userOptions.find((option) => option.value._id === user._id);
    if (curr) return;
    userOptions.push({
      label: user.Name,
      value: user
    });
  });

  return userOptions;
}
